/* eslint-disable*/
import http from 'axios'
import Vue from 'vue'
// import qs from 'qs'
// import { Message } from 'element-ui'

 function get(url, transition,data) {
  var corsUrl = Vue.prototype.$apiUrl

  return new Promise((res, err) => {
    http({
      method: 'get',
      url: corsUrl + url,
      params: data,
      headers:{
        "Content-Type":"application/json",
        'XX-Token': localStorage.getItem('token')?localStorage.getItem('token'):'',
        'XX-Api-Version': '1.0',
        'XX-App-Version': '2.0',
        'XX-Device-Type': 'pc'
      }
    })
      .then((response) => {
        if (response.data.code == 200) {
        	res(response.data)
        } else if(response.data.code == 10001) {
        	this.$router.push('/login')
        }else{
        	res(response.data)
        }
      })
      .catch((error) => {
        let errorInfo=error.toJSON()
        if(errorInfo.message == 'Network Error') return 

        this.$router.push('/login')
        err(error)
      })
  })
}

 function post(url, data, noload) {
  var corsUrl = Vue.prototype.$apiUrl
  return new Promise((res, err) => {
    http({
      method: 'post',
      url: corsUrl + url,
      data: data,
      headers:{
        "Content-Type":"application/json",
        'XX-Token': localStorage.getItem('token')?localStorage.getItem('token'):'',
        'XX-Api-Version': '1.0',
        'XX-App-Version': '2.0',
        'XX-Device-Type': 'pc'
      }
    })
      .then((response) => {
        if (response.data.code == 200) {
        	res(response.data)
        } else if(response.data.code == 10001) {
        	this.$router.push('/login')
        }else{
        	res(response.data)
        }
      })
      .catch((error) => {
        let errorInfo=error.toJSON()
        if(errorInfo.message == 'Network Error') return

        this.$router.push('/login')
        err(error)
      })
  })
}
export default({
  get: get,
  post: post
})



// WEBPACK FOOTER //
// ./src/request/request.js